import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import { AppointmentAlert, DataList } from '@classity-edtech/ui-base/dist/components/Displays';

export type DataList = {
  type?: 'dataList' | 'auth' | 'empty';
  tabs?: { label: string; active: boolean; action: () => void }[];
  newTransactionButton: {
    label: string;
    disabled?: boolean;
    action: () => void;
  };
  transactionButtons: {
    icon?: JSX.Element;
    column1?: { title?: string; description?: string };
    column2?: { title?: string; description?: string };
    column3?: { title?: string; description?: string };
    isActive?: boolean;
    disabled?: boolean;
    action: () => void;
  }[];
  column1Header?: string;
  column2Header?: string;
  currentPage?: number;
  numPages?: number;
  handlePageClick?: (page: number) => void;
  header: string;
  isFetching?: boolean;
};

export type AppointmentAlert = {
  profile: {
    name: string;
    src: string;
    bio?: string;
    rating?: number;
    followers?: number;
    actions?: JSX.Element;
    followAction?: () => void;
  };
  cta: {
    label: string;
    action: () => void;
  };
  appointmentDate: Date;
  info: string;
};

export interface HomeProps extends MuiBoxProps {
  dataList: DataList;
  appointmentAlert?: AppointmentAlert;
}

export const DataListComp = ({ className, appointmentAlert, dataList }: HomeProps) => {
  return (
    <Box className={className}>
      <Stack sx={{ gap: { xs: 1, md: 2 } }}>
        <Typography variant='subtitle3' data-testid={`data-list-component-header`}>
          {dataList.header}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: 4,
            width: '100%',
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Box sx={{ width: '100%' }}>
            <DataList {...dataList} />
          </Box>

          {appointmentAlert && (
            <Box sx={{ maxWidth: { xs: '100%', md: '274px' } }}>
              <AppointmentAlert {...appointmentAlert} />
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

DataListComp.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

DataListComp.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(DataListComp)(
  ({ theme }) => `
`,
);
